module.exports = __webpack_public_path__ + "img/informes-backup.2e76a805.jpeg";